import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Thông báo ")
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "name" }, "Họ và tên", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("small", {
  id: "name-help",
  class: "p-error"
}, "* Bắt buộc nhập tên bệnh nhân.", -1)
const _hoisted_6 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "phone_number" }, "Số điện thoại", -1)
const _hoisted_8 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { for: "symptoms" }, "Triệu chứng bệnh", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("small", {
  id: "symptoms-help",
  class: "p-error"
}, "* Bắt buộc phải triệu chứng bệnh.", -1)
const _hoisted_11 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "address" }, "Địa chỉ (Nơi cư trú)", -1)
const _hoisted_13 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "province" }, "Chọn Tỉnh/Thành Phố", -1)
const _hoisted_15 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "district" }, "Chọn Quận/Huyện", -1)
const _hoisted_17 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "ward" }, "Chọn Phường/Xã", -1)
const _hoisted_19 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { for: "date" }, "Chọn ngày khám", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-field p-col-12 p-md-6"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { for: "time" }, "Chọn giờ khám", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1)
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "p-dropdown-car-option" }
const _hoisted_28 = { class: "p-grid p-m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_Fragment, null, [
    ($setup.appConfig.address)
      ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
          content: _withCtx(() => [
            _createVNode("div", {
              innerHTML: $setup.appConfig.address
            }, null, 8, ["innerHTML"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.appConfig.notice)
      ? (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
          title: _withCtx(() => [
            _hoisted_1
          ]),
          content: _withCtx(() => [
            _createVNode("div", {
              innerHTML: $setup.appConfig.notice
            }, null, 8, ["innerHTML"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Panel, { header: "Đặt lịch khám bệnh" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              id: "name",
              type: "text",
              modelValue: $setup.book.full_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.book.full_name = $event)),
              placeholder: "Vui lòng nhập đầy đủ tên bệnh nhân ..."
            }, null, 8, ["modelValue"]),
            _hoisted_5
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputText, {
              id: "phone_number",
              type: "phone",
              modelValue: $setup.book.phone_number,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.book.phone_number = $event)),
              placeholder: "Vui lòng nhập số điện thoại của bệnh nhân ..."
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "symptoms",
              modelValue: $setup.book.symptoms,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.book.symptoms = $event)),
              type: "text",
              placeholder: "Vui lòng nhập triệu chứng bệnh ..."
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_InputText, {
              id: "address",
              modelValue: $setup.book.address,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.book.address = $event)),
              type: "text",
              placeholder: "Vui lòng nhập địa chỉ nhà (đường/tổ/xóm) ..."
            }, null, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Dropdown, {
              id: "province",
              filter: true,
              showClear: true,
              modelValue: $setup.province,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.province = $event)),
              onChange: $setup.selectProvince,
              options: $setup.provinces,
              optionLabel: "province_name",
              optionValue: "province_code",
              placeholder: "Vui lòng lựa chọn Tỉnh/Thành phố..."
            }, null, 8, ["modelValue", "onChange", "options"])
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_Dropdown, {
              id: "district",
              filter: true,
              showClear: true,
              modelValue: $setup.district,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.district = $event)),
              options: $setup.districts,
              onChange: $setup.selectDistrict,
              optionLabel: "district_name",
              optionValue: "district_code",
              placeholder: "Vui lòng lựa chọn Quận/Huyện..."
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_Dropdown, {
              id: "ward",
              filter: true,
              showClear: true,
              modelValue: $setup.ward,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($setup.ward = $event)),
              options: $setup.wards,
              optionLabel: "ward_name",
              optionValue: "ward_code",
              placeholder: "Vui lòng lựa chọn Phường/Xã..."
            }, null, 8, ["modelValue", "options"])
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_Calendar, {
              id: "date",
              dateFormat: "dd-mm-yy",
              modelValue: $setup.book.date_time,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.book.date_time = $event)),
              onDateSelect: $setup.loadSlots,
              disabled: $setup.isLoadingSlots
            }, null, 8, ["modelValue", "onDateSelect", "disabled"])
          ]),
          ($setup.book.date_time)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Dropdown, {
                  id: "time",
                  inputId: "state",
                  modelValue: $setup.slot,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ($setup.slot = $event)),
                  options: $setup.slots,
                  emptyMessage: "Không thể đăng ký vào ngày này",
                  placeholder: "Giờ khám"
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          _createVNode("span", null, _toDisplayString($setup.formatTime(slotProps.value.date_time)), 1)
                        ]))
                      : ($setup.isLoadingSlots)
                        ? (_openBlock(), _createBlock("span", _hoisted_24, [
                            _hoisted_25
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createVNode("div", _hoisted_27, [
                      _createVNode("span", null, _toDisplayString($setup.formatTime(slotProps.option.date_time)), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode(_component_Button, {
            class: "p-col-12 p-md-3 p-mt-2",
            disabled: !$setup.valid() || $setup.isSubmitting,
            label: "Đặt lịch",
            icon: "pi pi-check",
            onClick: $setup.submit,
            iconPos: "right"
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      _: 1
    })
  ], 64))
}